import React from "react";
import Stack from "components/common/Stack";
import Avatar from "components/common/Avatar";
import Header from "components/Layout/Header";
import Sidebar from "components/Layout/Sidebar";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
const routes = {
  demoComponents: `/demo`,
  dashboard: `/dashboard`,
  manufacturer: `/manufacturer`,
  connector: `/connector`,
  amenities: `/amenities`,
  coupons: `/coupons`,
  vehicles: '/vehicles',
  addvehicles: '/vehicles/addvehicles',
  addconnector: '/Connector/addConnector',
  networks: `/networks`,
  navigation:'/navigation',
  tripDetail:'/trip',
  chargingstation:'/chargingstation',
  checkin:'/checkin',
  searchhistory:'/searchhistory',
  feedback:'/feedback',
  request: '/request',
  charging: `/charging`,
  customer: `/customer`,
  customerdata:'/customerdata',
  booking: `/booking`,
  leads: '/leads',
  vendor: `/vendor`,
  configuration: `/configuration`,
  faqCategory: `/faq/category`,
  faqQuestions: `/faqs`,
  query: `/query`

};

class LayoutContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDrawerExpanded: true,
      isNotificationDropdownOpen: false,
      notificationAnchorEl: null,
      logoutsuccess: false,
    };
  }

  componentDidMount() {
    const reqChargingCount = this.props.reqChargingCount;

    const reqCount = this.props.reqCount;
    if (!reqCount) {
      this.props.getVendorCountAction();
    }
    if (!reqChargingCount) {
      this.props.getChargingStationCountAction();
    }
  }

  handleDrawerToggle = (isDrawerExpanded) => {
    this.setState({ isDrawerExpanded });
  };

  handleNotificationOpen = (e) => {
    this.setState({
      notificationAnchorEl: e.currentTarget,
      isNotificationDropdownOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationAnchorEl: null,
      isNotificationDropdownOpen: false,
    });
  };

  handleLogoutClick = () => {
    this.setState({ logoutsuccess: true });

    setTimeout(() => {
      this.props.logoutAction();
      this.props.history.replace("/login");
    }, 2000);
  };

  handleSidebarRedirection = (pathname) => {
    if (window.innerWidth < 900) {
      this.handleDrawerToggle(false);
    }
    this.props.history.push(pathname);
  };

  isActiveRoute = (pathname) => {
    const url = this.props.location.pathname.slice(
      0,
      this.props.location.pathname.lastIndexOf("/")
    );

    if (this.props.location.pathname === pathname) {
      return true;
    } else if (
      this.props.location.pathname === "/add/station" &&
      pathname === "/charging"
    ) {
      return true;
    } else if (
      this.props.location.pathname === "/add/station" &&
      pathname === "/charging"
    ) {
      return true;
    } else if (
      this.props.location.pathname === "/vehicle/manufacturer" &&
      pathname === "/manufacturer"
    ) {
      return true;
    } else if (
      this.props.location.pathname === "/vehicle/model" &&
      pathname === "/manufacturer"
    ) {
      return true;
    } else if (
      this.props.location.pathname === "/add/connectors" &&
      pathname === "/manufacturer"
    ) {
      return true;
    } else if (
      this.props.location.pathname === "/view/details" &&
      pathname === "/manufacturer"
    ) {
      return true;
    } else if (
      this.props.location.pathname === "/map" &&
      pathname === "/manufacturer"
    ) {
      return true;
    } else if (
      this.props.location.pathname === "/charging/request" &&
      pathname === "/charging"
    ) {
      return true;
    } else if (
      this.props.location.pathname === "/vehicles/addvehicles" &&
      pathname === "/vehicles"
    ) {
      return true;
    } else if (
      this.props.location.pathname === "/connector/addconnector" &&
      pathname === "/connector"
    ) {
      return true;
    }
    else if (
      this.props.location.pathname === "/add/coupons" &&
      pathname === "/coupons"
    ) {
      return true;
    } else if (url === "/edit/station" && pathname === "/charging") {
      return true;
    } else if (url === "/station/details" && pathname === "/charging") {
      return true;
    } else if (url === "/customer/details" && pathname === "/customer") {
      return true;
    }  else if (url === "/checkIn/customer/details" && pathname === "/checkin") {
      return true;
    } else if (
      this.props.location.pathname === "/request/details" &&
      pathname === "/vendor"
    ) {
      return true;
    } else if (
      this.props.location.pathname === "/vendor/config" &&
      pathname === "/vendor"
    ) {
      return true;
    } else if (
      this.props.location.pathname === "/vendor/request" &&
      pathname === "/vendor"
    ) {
      return true;
    } else if (
      this.props.location.pathname === "/request/details/Vendor" &&
      pathname === "/vendor"
    ) {
      return true;
    } else {
      return false;
    }
  };

  render() {
    const {
      isDrawerExpanded,
      isNotificationDropdownOpen,
      notificationAnchorEl,
    } = this.state;
    const { children, notifications = [] } = this.props;

    const sidebarMenuConfig = [
      {
        type: "item",
        primaryText: "Dashboard",

        icon: this.isActiveRoute(routes.dashboard) ? (
          <Avatar
            sx={{
              width: 25,
              height: 25,
            }}
            imgProps={{
              style: { resizeMode: "cover", width: 55, height: 55 },
            }}
            src={"/images/Icon01.svg"}
            variant="body1"
            title="F"
          ></Avatar>
        ) : (
          <Avatar
            sx={{
              width: 22,
              height: 22,
            }}
            src={"/images/DashboardIcon.svg"}
            variant="body1"
            title="F"
          />
        ),
        onClick: () => this.handleSidebarRedirection(routes.dashboard),
        isActive: this.isActiveRoute(routes.dashboard),
      },

      // ************
      {
        type: "item",
        primaryText: "Vendor",
        icon: this.isActiveRoute(routes.vendor) ? (
          <Avatar
            sx={{
              width: 25,
              height: 25,
            }}
            imgProps={{
              style: { resizeMode: "cover", width: 55, height: 55 },
            }}
            src={"/images/vendor.svg"}
            variant="body1"
            title="F"
          ></Avatar>
        ) : (
          <Avatar
            sx={{
              width: 22,
              height: 22,
            }}
            src={"/images/AdminIcon.svg"}
            variant="body1"
            title="F"
          />
        ),

        icon2:
          this.props?.reqCount > 0 ? (
            <Box>
              <Typography
                sx={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "50px 50px",
                  background: this.isActiveRoute(routes.vendor)
                    ? "#fff"
                    : "rgba(25, 170, 105, 0.12)",
                  fontSize: "12px",
                  color: "#111",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {this.props?.reqCount}
              </Typography>
            </Box>
          ) : null,

        onClick: () => this.handleSidebarRedirection(routes.vendor),
        isActive: this.isActiveRoute(routes.vendor),
      },
      // ********
      {
        type: "secondry",
        onClick: () => this.handleDrawerToggle(true),
        primaryText: (
          <>
            <Stack
              direction="row"
              alignItems="center"
            >
              <Typography fontSize={"16px"}> Configurations </Typography>
            </Stack>
          </>
        ),

        secondary: [
          {
            primaryText: (
              <>
                <Stack alignItems="center">
                  <Typography fontSize={"17px"} marginLeft="-40px">
                    Vehicles
                  </Typography>
                </Stack>
              </>
            ),
            onClick: () => this.handleSidebarRedirection(routes.vehicles),
            isActive: this.isActiveRoute(routes.vehicles),
          },

          {
            primaryText: (
              <>
                <Stack alignItems="center">
                  <Typography fontSize={"17px"} marginLeft="-30px">
                    Connector
                  </Typography>
                </Stack>
              </>
            ),
            onClick: () => this.handleSidebarRedirection(routes.connector),
            isActive: this.isActiveRoute(routes.connector),
          },
          {
            primaryText: (
              <>
                <Stack alignItems="center">
                  <Typography fontSize={"17px"} marginLeft="-13px">
                    Manufacturer
                  </Typography>
                </Stack>
              </>
            ),
            onClick: () => this.handleSidebarRedirection(routes.manufacturer),
            isActive: this.isActiveRoute(routes.manufacturer),
          },

          {
            primaryText: (
              <>
                <Stack alignItems="center">
                  <Typography fontSize={"17px"} marginLeft="-36px">
                    Amenities
                  </Typography>
                </Stack>
              </>
            ),
            onClick: () => this.handleSidebarRedirection(routes.amenities),
            isActive: this.isActiveRoute(routes.amenities),
          },

          {
            type: "item",
            primaryText: (
              <>
                <Stack alignItems="center">
                  <Typography fontSize={"17px"} marginLeft="-44px">
                    Coupons
                  </Typography>
                </Stack>
              </>
            ),
            onClick: () => this.handleSidebarRedirection(routes.coupons),
            isActive: this.isActiveRoute(routes.coupons),
          },
          {
            type: "item",
            primaryText: (
              <>
                <Stack alignItems="center">
                  <Typography fontSize={"17px"} marginLeft="22.5px">
                    Charging Networks
                  </Typography>
                </Stack>
              </>
            ),
            onClick: () => this.handleSidebarRedirection(routes.networks),
            isActive: this.isActiveRoute(routes.networks),
          },
          {
            type: "item",
            primaryText: (
              <>
                <Stack alignItems="left">
                  <Typography fontSize={"17px"} marginLeft="22.5px">
                    Request
                  </Typography>
                </Stack>
              </>
            ),
            onClick: () => this.handleSidebarRedirection(routes.request),
            isActive: this.isActiveRoute(routes.request),
          },
        ],

        icon: (
          <Avatar
          sx={{
            width: 25,
            height: 25,
          }}
          imgProps={{
            style: { resizeMode: "cover", width: 55, height: 55 },
          }}
          src={"/images/confi.svg"}
          variant="body1"
          title="F"
        ></Avatar>
        ),
      },
      // *******

      {
        type: "item",
        primaryText: "Configuration",

        icon: this.isActiveRoute(routes.configuration) ? (
          <Avatar
            sx={{
              width: 25,
              height: 25,
            }}
            imgProps={{
              style: { resizeMode: "cover", width: 55, height: 55 },
            }}
            src={"/images/confi.svg"}
            variant="body1"
            title="F"
          ></Avatar>
        ) : (
          <Avatar
            sx={{
              width: 14,
              height: 16,
            }}
            src="/images/ConfigIcon.svg"
            variant="body1"
            title="F"
          ></Avatar>
        ),
        onClick: () => this.handleSidebarRedirection(routes.configuration),
        isActive: this.isActiveRoute(routes.configuration),
      },
      {
        type: "item",
        primaryText: "Charging Station ",
        icon: this.isActiveRoute(routes.charging) ? (
          <Avatar
            sx={{
              width: 25,
              height: 25,
            }}
            imgProps={{
              style: { resizeMode: "cover", width: 55, height: 55 },
            }}
            src={"/images/charg.svg"}
            variant="body1"
            title="F"
          ></Avatar>
        ) : (
          <Avatar
            sx={{
              width: 22,
              height: 22,
            }}
            src={"/images/ActivityIcon.svg"}
            variant="body1"
            title="F"
          />
        ),
        icon2:
          this.props?.reqChargingCount > 0 ? (
            <Box>
              <Typography
                sx={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "50px 50px",
                  background: this.isActiveRoute(routes.chargingstation)
                    ? "#ffff"
                    : "rgba(25, 170, 105, 0.12)",
                  fontSize: "12px",
                  color: "#111",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {this.props?.reqChargingCount}
              </Typography>
            </Box>
          ) : null,

        onClick: () => this.handleSidebarRedirection(routes.chargingstation),
        isActive: this.isActiveRoute(routes.chargingstation),
      },
     
      {
        type: "item",
        primaryText: "Customers",
        icon: this.isActiveRoute(routes.customerdata) ? (
          <Avatar
            sx={{
              width: 25,
              height: 25,
            }}
            imgProps={{
              style: { resizeMode: "cover", width: 55, height: 55 },
            }}
            src={"/images/cus.svg"}
            variant="body1"
            title="F"
          ></Avatar>
        ) : (
          <Avatar
            sx={{
              width: 22,
              height: 22,
            }}
            src="/images/ChargingIcon.svg"
            variant="body1"
            title="F"
          ></Avatar>
        ),
        onClick: () => this.handleSidebarRedirection(routes.customerdata),
        isActive: this.isActiveRoute(routes.customerdata),
      },
      // customer  accounts




      {
        type: "secondryAC",
        onClick: () => this.handleDrawerToggle(true),
        primaryText: (
          <>
            <Stack
              direction="row"
              alignItems="center"
            >
              <Typography fontSize={"16px"}> Customer Accounts </Typography>
            </Stack>
          </>
        ),

        secondaryAC: [
          {
            primaryText: (
              <>
                <Stack alignItems="center">
                  <Typography fontSize={"17px"} marginLeft="-35px">
                  Trip Detail
                  </Typography>
                </Stack>
              </>
            ),
            onClick: () => this.handleSidebarRedirection(routes.tripDetail),
            isActive: this.isActiveRoute(routes.tripDetail),
          },

          {
            primaryText: (
              <>
                <Stack alignItems="center">
                  <Typography fontSize={"17px"} marginLeft="-35px">
                  Navigation
                  </Typography>
                </Stack>
              </>
            ),
            onClick: () => this.handleSidebarRedirection(routes.navigation),
            isActive: this.isActiveRoute(routes.navigation),
          },

          {
            primaryText: (
              <>
                <Stack alignItems="center">
                  <Typography fontSize={"17px"} marginLeft="-13px">
                    Search History
                  </Typography>
                </Stack>
              </>
            ),
            onClick: () => this.handleSidebarRedirection(routes.searchhistory),
            isActive: this.isActiveRoute(routes.searchhistory),
          },
          {
            primaryText: (
              <>
                <Stack alignItems="center">
                  <Typography fontSize={"17px"} marginLeft="-55px">
                 Check In
                  </Typography>
                </Stack>
              </>
            ),
            onClick: () => this.handleSidebarRedirection(routes.checkin),
            isActive: this.isActiveRoute(routes.checkin),
          },
          {
            primaryText: (
              <>
                <Stack alignItems="center">
                  <Typography fontSize={"17px"} marginLeft="-40px">
                 Feedback
                  </Typography>
                </Stack>
              </>
            ),
            onClick: () => this.handleSidebarRedirection(routes.feedback),
            isActive: this.isActiveRoute(routes.feedback),
          },
        ],

        icon: (
          <Avatar
            sx={{
              width: 15,
              height: 15,
            }}
            src="/images/set.jpeg"
            variant="body1"
            title="F"
          ></Avatar>
        ),
      },



      // end customer account
      {
        type: "item",
        primaryText: "Bookings",
        icon: this.isActiveRoute(routes.booking) ? (
          <Avatar
            sx={{
              width: 25,
              height: 25,
            }}
            imgProps={{
              style: { resizeMode: "cover", width: 55, height: 55 },
            }}
            src={"/images/booking.png"}
            variant="body1"
            title="F"
          ></Avatar>
        ) : (
          <Avatar
            sx={{
              width: 22,
              height: 22,
            }}
            src="/images/BookingIcon.svg"
            variant="body1"
            title="F"
          ></Avatar>
        ),
        onClick: () => this.handleSidebarRedirection(routes.booking),
        isActive: this.isActiveRoute(routes.booking),
      },
      {
        type: "item",
        primaryText: "Leads",
        icon: this.isActiveRoute(routes.leads) ? (
          <Avatar
            sx={{
              width: 25,
              height: 25,
            }}
            imgProps={{
              style: { resizeMode: "cover", width: 55, height: 55 },
            }}
            src={"/images/booking.png"}
            variant="body1"
            title="F"
          ></Avatar>
        ) : (
          <Avatar
            sx={{
              width: 22,
              height: 22,
            }}
            src="/images/BookingIcon.svg"
            variant="body1"
            title="F"
          ></Avatar>
        ),
        onClick: () => this.handleSidebarRedirection(routes.leads),
        isActive: this.isActiveRoute(routes.leads),
      },
      // *******

      {
        type: "item",
        primaryText: "FAQs",

        icon: this.isActiveRoute(routes.faqQuestions) ? (
          <Avatar
            sx={{
              width: 25,
              height: 25,
            }}
            imgProps={{
              style: { resizeMode: "cover", width: 55, height: 55 },
            }}
            src={"/images/Icon01.svg"}
            variant="body1"
            title="F"
          ></Avatar>
        ) : (
          <Avatar
            sx={{
              width: 22,
              height: 22,
            }}
            src={"/images/DashboardIcon.svg"}
            variant="body1"
            title="F"
          />
        ),
        onClick: () => this.handleSidebarRedirection(routes.faqQuestions),
        isActive: this.isActiveRoute(routes.faqQuestions),
      },



      {
        type: "logout",
        primaryText: "Logout",

        avatar: (
          <Avatar
            sx={{
              width: 22,
              height: 22,
              padding: "10px",
            }}
            src="/images/LogoutIcon.png"
            variant="body1"
            title="F"
          ></Avatar>
        ),
        onclick: () => this.handleLogoutClick(),
      },
    ];

    return (
      <Stack direction="row" sx={{ minHeight: "100vh" }}>
        <Snackbar
          open={this.state.logoutsuccess}
          autoHideDuration={1000}
          onClose={() => this.setState({ logoutsuccess: false })}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert severity="success">Logout Successfully</Alert>
        </Snackbar>

        <Sidebar
          onLogoutClick={this.handleLogoutClick}
          menuConfig={sidebarMenuConfig}
          isDrawerExpanded={isDrawerExpanded}
          onDrawerToggle={this.handleDrawerToggle}
        />

        <Stack
          sx={{
            flex: 1,
            backgroundColor: {
              xs: "background.paper",
              md: "grey.100",
            },
            width: "80%",
          }}
        >
          <Header
            Profile={this.props.profile.thumbnail}
            onDrawerToggle={this.handleDrawerToggle}
            isDrawerExpanded={isDrawerExpanded}
            notifications={notifications}
            onNotificationOpen={this.handleNotificationOpen}
            onNotificationClose={this.handleNotificationClose}
            isNotificationDropdownOpen={isNotificationDropdownOpen}
            notificationAnchorEl={notificationAnchorEl}
          />
          <Stack
            sx={{
              flex: 1,
              maxWidth: "100%",
              px: { xs: 2, md: 3 },
              py: 0,
              pb: { xs: 2, md: 3 },
            }}
          >
            {children}
          </Stack>
        </Stack>
      </Stack>
    );
  }
}

export default LayoutContainer;
